/** @jsxImportSource @emotion/react */
import React, { useEffect, useRef, useState } from 'react';
import { useCommonModal } from 'hooks/useCommonModal';
import { useMessageBar } from 'hooks/useMessageBar';
import { useTranslation } from 'react-i18next';
import { Code } from 'models/common/CommonCode';
import _ from 'lodash';
import {
  AsstRvwType,
  AsstTpCd,
  IdleAssetCondition,
  IdleAssetDetail,
} from '../../models/asst/IdleAsset';
import IdleAssetReviewGrid from './management/IdleAssetReviewGrid';
import IdleAssetEquipmentGrid from './management/IdleAssetEquipmentGrid';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useLoading } from '../../components/process/Loading';
import IdleAssetRequestInfo from './management/IdleAssetRequestInfo';
import { ManagementMode } from '../../models/common/Common';

interface PageLocationState {
  rvwReqId?: string;
  asstTpCd?: string;
  mode?: ManagementMode;
}

/**
 * 불용자산 검토내역(결과목록)
 * @constructor
 * -------------------------------------------------------------------------------------
 *  Date.       author         Description
 * -------------------------------------------------------------------------------------
 * 2025.10.21   sungim.kim2   최초생성
 */
const IdlAssetReviewResultDetailPage = () => {
  const { t } = useTranslation();
  const { openMessageBar } = useMessageBar();
  const { openCommonModal } = useCommonModal();
  const [code, setCode] = useState<any>();
  const [asstRvwRltDivsCd, setAsstRvwRltDivsCd] = useState<Code[]>([]);

  // dataSet
  const [rowData, setRowData] = useState<IdleAssetDetail>(); //detail 정보
  const [isAsstMstComplete, setAsstMstComplete] = useState<boolean>(false);

  const [isRefresh, setRefresh] = useState<boolean>(false);

  const equipRef = useRef<any>();
  const reviewRef = useRef<any>();
  const infoRef = useRef<any>();

  const [isAsstTpCd, setAsstTpCd] = useState<string>('');
  const { openLoading } = useLoading();
  const [searchParams] = useSearchParams();
  const locationState: PageLocationState = useLocation().state;

  const [condition, setCondition] = useState<IdleAssetCondition>({});

  useEffect(() => {
    if (!locationState?.rvwReqId) return;
    if (condition.rvwReqId !== locationState.rvwReqId) {
      const initialCondition = {
        rvwReqId: locationState.rvwReqId,
        asstTpCd: locationState?.asstTpCd,
      };
      setCondition(initialCondition);
      const timer = setTimeout(() => {
        infoRef.current?.search(initialCondition);
      }, 0); // 마운트 이후 실행
      return () => clearTimeout(timer);
    }
  }, [locationState?.rvwReqId]);

  useEffect(() => {
    if (!_.isNull(searchParams.get('rvwReqId'))) {
      const initialCondition = {
        rvwReqId: searchParams.get('rvwReqId') || '',
        asstTpCd: searchParams.get('asstTpCd') || '',
      };
      setCondition(initialCondition);
      const timer = setTimeout(() => {
        infoRef.current?.search(initialCondition);
      }, 0); // 마운트 이후 실행
      return () => clearTimeout(timer);
    }
  }, [searchParams]); // searchParms가 변경될 때마다 실행

  const handleConditionChange = (newCondition: Partial<IdleAssetCondition>) => {
    setCondition((prev) => {
      const updatedCondition = { ...prev, ...newCondition };
      equipRef.current?.search(updatedCondition);
      return updatedCondition;
    });
  };
  return (
    <>
      {/* 요청정보 view */}
      <IdleAssetRequestInfo
        openMode={AsstRvwType.READ}
        ref={infoRef}
        condition={condition}
        handleConditionChange={handleConditionChange}
      />

      {/* 설비,기타자산 리스트 */}
      <IdleAssetEquipmentGrid
        ref={equipRef}
        openMode={AsstRvwType.READ}
        gridHeight={200}
        condition={condition}
        onClikDetail={(item) => {
          reviewRef.current?.search(item);
        }}
        onRefresh={() => {
          // 법인별 검토 현황 재조회
        }}
      />

      <IdleAssetReviewGrid
        ref={reviewRef}
        resultCfm={false}
        isAsstMstComplete={isAsstMstComplete}
      />
    </>
  );
};

export default IdlAssetReviewResultDetailPage;
